import MaterialTable from "@material-table/core";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {generateSueDocumentationForDO} from "../../actions/driveOffs";
import {changeTabInSidebar} from "../../actions/sidebar";
import {clearZendeskTicket} from "../../actions/ticket";
import {CLEAR_TICKET_FOR_EDIT} from "../../actions/types";
import {
  cancelTicket,
  cancelTicketFee,
  changeTicketArchivedStatus,
  changeTicketDocumentLanguageByNumber,
  changeTicketLegalStatusByPZAdminAndSysAdmin,
  clearOwnersForGSAndPZEdit,
  closeTicket,
  commentTicket,
  createOperationalDoc,
  generateLastReminder,
  generatePaymentSlipReminder,
  generatePaymentSlipWithPhotos,
  getAllDriveOffs,
  manuallyPayTicketBySysadmin,
  modifyTicket,
  resetTicket
} from "../../actions/violations";
import {DriveOffColumns} from "../../columns/driveOffColumns";
import MagnifyingGlass from "../../common/assets/magnifying-glass.svg";
import {useGlobalState} from "../../GlobalContext";
import keycloak from "../../keycloak";
import GridProgress from "../../reusable/gridProgress";
import LiveRegion from "../../reusable/liveRegion";
import LoadingIndicator from "../../reusable/loadingIndicator";
import {optionsGeneralArchivedTickets} from "../../reusable/optionsForTables";
import Pagination from "../../reusable/paginationForViolations";
import {paginationStyle, toolbarStyles, useStyles, useStylesForMaterial,} from "../../reusable/styles";
import Sidebar from "../../sidebar/sidebar";
import {useDelayedBusy} from "../../utils/useDelayedBusy";
import EditGasStationModal from "../gasStation/editGasStationModal";
import GasStationDetailsModal from "../gasStation/gasStationDetailsModal";
import ModalForPropotionalPicture from "../modalForPropotionalPicture";
import ModalForVideoPlaying from "../modalForVideoPlaying";
import ObjectionModal from "../objectionModal";
import OwnerDetailsModal from "../owner/ownerDetailsModal";
import DateModal from "./dateModal";
import ModalAddComment from "./modalAddComment";
import ModalAuditTicket from "./modalAuditTicket";
import ModalCancelTicket from "./modalCancelTicket";
import ModalCloseTicket from "./modalCloseTicket";
import ModalCustomerDocumentHistory from "./modalCustomerDocumentHistory";
import ModalEditTicket from "./modalEditTicket";
import ModalManualPayment from "./modalManualPayment";
import ModalResetTicket from "./modalResetTicket";
import ModalSendViaPingen from "./modalSendViaPingen";
import ModalZendeskDetails from "./modalZendeskDetails";
import Style from "./violations.module.css";
import ViolatorsAddressLockedModal from "./violatorsAddressLockedModal";

export default function DriveOff() {
  const { t } = useTranslation();
  const classes = useStyles();
  const classesMaterial = useStylesForMaterial();
  const classesForm = toolbarStyles();
  const dispatch = useDispatch();
  const { violations, last, numberOfElements, empty } = useSelector(
    (state) => state.violations
  );
  const { isLoading, isGridLoading } = useSelector((state) => state.loader);
  // quiet, table scoped progress for grid refetches; the page indicator stays
  // for page level work such as generating a document
  const showGridProgress = useDelayedBusy(isGridLoading, { delay: 150 });
  const [showPictures, setShowPictures] = useState(false);
  const [showVideos, setShowVideos] = useState(false);

  const [violatorDetails, setViolatorDetails] = useState(null);
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [openManualPaymentModal, setOpenManualPaymentModal] = useState(false);
  const [objectionOpen, setObjectionOpen] = useState(false);
  const [objection, setObjection] = useState({});
  const [height, setHeight] = useState(window.innerHeight);
  const [showArchivedList, setShowArchivedList] = useState(false);
  const [showArchivedTickets, setShowArchivedTickets] = useState(false);
  const [archivedCellStyle, setArchivedCellStyle] = useState(false);
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [ticketAuditModal, setTicketAuditModal] = useState(false);
  const [ticketForAudit, setTicketForAudit] = useState(false);
  const [customerDocumentHistoryModal, setCustomerDocumentHistoryModal] = useState(false);
  const [ticketNumberForCustomerDocumentHistory, setTicketNumberForCustomerDocumentHistory] = useState(false);
  const [editTicketModal, setEditTicketModal] = useState(false);
  const [resetTicketModal, setResetTicketModal] = useState(false);
  const [ticketForEdit, setTicketForEdit] = useState(false);
  const [ticketForReset, setTicketForReset] = useState(false);
  const [pendingDocumentAction, setPendingDocumentAction] = useState(null);
  const [generatingDocument, setGeneratingDocument] = useState(false);
  const [ticketNumberInCommentModal, setTicketNumberInCommentModal] =
    useState(false);
  const [commentDefaultValue, setCommentDefaultValue] = useState("");
  const [openViolatorsAddressLocked, setOpenViolatorsAddressLocked] =
    useState(false);

  const [dateModalOpen, setDateModalOpen] = useState(false);

  const [zendeskDetailsModalOpen, setZendeskDetailsModalOpen] = useState(false);
  const [zendeskId, setZendeskId] = useState(null);

  const [openModalOwnerDetails, setOpenModalOwnerDetails] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState("");
  const [selectedGasStationZoneId, setSelectedGasStationZoneId] = useState("");
  const [openModalGasStationZoneDetails, setOpenModalGasStationZoneDetails] =
    useState(false);
  const [openCancelTicketModal, setOpenCancelTicketModal] = useState(false);
  const [openCloseTicketModal, setOpenCloseTicketModal] = useState(false);  
  const [openCancelTicketFeeModal, setOpenCancelTicketFeeModal] = useState(false);
  const [openModalEditGasStationZone, setOpenModalEditGasStationZone] =
    useState(false);
  const { state, updateState } = useGlobalState();
  const handleCloseModalForPictures = (event, newValue) => {
    setShowPictures(false);
  };

  const handleCloseModalForVideos = (event, newValue) => {
    setShowVideos(false);
  };

  const handleResize = () => {
    setHeight(window.innerHeight);
  };
  const refDate = useRef(null);

const createDefaultFilter = () => ({
  take: 10,
  skip: 0,
  page: 0,
  sort: {
    path: "date",
    desc: true,
  },
  filter: {
    and: [
      {
        filter: "neq",
        path: "status",
        value: "NEW",
      },
      {
        filter: "eq",
        path: "deleted",
        value: false,
      },
      {
        filter: "isnull",
        path: "parkingZone",
      },
      {
        filter: "eq",
        path: "archived",
        value: false,
      },
      {
        filter: "con",
        path: "number",
        value: "",
      },
      {
        filter: "con",
        path: "licensePlate",
        value: "",
      },
      {
        filter: "con",
        path: "gasStationZone.number",
        value: "",
      },
      {
        filter: "con",
        path: "reporterName",
        value: "",
      },
      {
        filter: "notnull",
        path: "status",
        value: "",
      },
      {
        filter: "notnull",
        path: "legalStatus",
        value: "",
      },
      {
        filter: "notnull",
        path: "userStatus",
        value: "",
      },
      {
        filter: "starts",
        path: "date",
        value: "",
      },
      {
        filter: "notnull",
        path: "id",
        value: "",
      },
      {
        filter: "con",
        path: "amount",
        value: "",
      },
      {
        filter: "con",
        path: "gasStationTicketDetails.category",
        value: "",
      },
    ],
  },
});
const [filter, setFilter] = useState(createDefaultFilter);

useEffect(() => {
  setFilter(createDefaultFilter());
}, [state.country]);

  useEffect(() => {
    const ourRequest = axios.CancelToken.source();
    dispatch(
      getAllDriveOffs(
        showArchivedTickets,
        setArchivedCellStyle,
        filter,
        ourRequest,
        state.country
      )
    );
    return () => {
      ourRequest.cancel("Cancelling in cleanup");
    };
  }, [dispatch, showArchivedTickets, filter, state.country]);

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);

  const generateDocumentation = async (number, licencePlate) => {
    await dispatch(generateSueDocumentationForDO(number, licencePlate));
  };

  const createOperationalDocument = (number, licencePlate) => {
    dispatch(createOperationalDoc(number, licencePlate));
  };

  const generateReminderPaymentSlip = async (number, licencePlate, sendViaPingen) => {
    await dispatch(
      generatePaymentSlipReminder(
        number,
        licencePlate,
        localStorage.getItem("beppoSelectedLanguage"),
        sendViaPingen
      )
    );
  };

  const generateLastReminderSlip = async (number, licencePlate, sendViaPingen) => {
    await dispatch(
      generateLastReminder(
        number,
        licencePlate,
        localStorage.getItem("beppoSelectedLanguage"),
        sendViaPingen
      )
    );
  };

  const generatePaymentSlip = async (number, licencePlate, sendViaPingen) => {
    await dispatch(
      generatePaymentSlipWithPhotos(
        number,
        licencePlate,
        localStorage.getItem("beppoSelectedLanguage"),
        sendViaPingen
      )
    );
  };

  const handleSendViaPingenConfirm = async (sendViaPingen) => {
    const action = pendingDocumentAction;
    // the modal stays open showing a spinner until the document is there
    setGeneratingDocument(true);
    try {
      await action.generate(action.number, action.licensePlate, sendViaPingen);
    } finally {
      setGeneratingDocument(false);
      setPendingDocumentAction(null);
    }
  };

  const cancelViolation = async (body) => {
    await dispatch(cancelTicket(body));
  };

  const manuallyPayTicket = async (manualPayment) => {
    dispatch(manuallyPayTicketBySysadmin(manualPayment));
  };
  const ticketCancel = async (ticketCancel) => {
    await dispatch(cancelTicket(ticketCancel));
  };
    const ticketFeeCancel = async (ticketCancel) => {
      await dispatch(cancelTicketFee(ticketCancel));
    };
  const cancelViolationFee = async (body) => {
    await dispatch(cancelTicketFee(body));
  };
  const ticketClose = async (ticketClose) => {
    await dispatch(closeTicket(ticketClose));
  };
  const changeTicketLegalStatus = async (id, status) => {
    await dispatch(changeTicketLegalStatusByPZAdminAndSysAdmin(id, status));
  };

  const handleResetTicket = async (keepHolderData) => {
    await dispatch(resetTicket(ticketForReset.id, keepHolderData));
    setResetTicketModal(false);
  };

  const changeTicketDocumentLanguage = async (number, language) => {
    await dispatch(changeTicketDocumentLanguageByNumber(number, language));
  };


  const archiveTicket = async (number) => {
    await dispatch(changeTicketArchivedStatus(number));
  };

  const toogleModalForComment = () => {
    setCommentDefaultValue("");
    setOpenCommentModal(!openCommentModal);
  };

  const addComment = (data) => {
    const dataForEdit = {
      ticketNumber: ticketNumberInCommentModal,
      comment: data.comment,
    };

    dispatch(commentTicket(dataForEdit));
    toogleModalForComment();
  };

  const editTicket = (data) => {
    dispatch(modifyTicket(data, setEditTicketModal));
  };

  const openGasStationZoneEditModal = () => {
    setOpenModalEditGasStationZone(true);
    setOpenModalGasStationZoneDetails(false);
  };

  useEffect(() => {
    dispatch(changeTabInSidebar(9));
  }, [dispatch]);

  const modifyArray = (array, name, value) => {
    const newArray = array.map((element) => {
      if (element.path == name) {
        element.value = value;
      }
      return element;
    });
    return newArray;
  };

  function toolbar() {
    return (
      <div className={classesForm.root}>
        <Grid container direction="row" className={Style.header}>
        <div className={Style.header}>
          <div className={Style.header__title}>{t("Sidebar.DriveOff")}</div>
        </div>   
             <button
               className={Style.header__addButton}
               onClick={() => {
                 setShowArchivedList(!showArchivedList);
                 setShowArchivedTickets(!showArchivedTickets);
                 const newArray = modifyArray(
                   [...filter.filter.and],
                   "archived",
                   !showArchivedTickets
                 );
                 setFilter({ ...filter, filter: { and: newArray } });
               }}
             >
               <p className={Style.header__addButton__text}>
                 {!showArchivedList
                   ? t("Violations.showArchivedTickets")
                   : t("Violations.hideArchivedTickets")}
               </p>
             </button>
         </Grid>
      </div>
    );
  }

  useEffect(() => {
    dispatch(clearOwnersForGSAndPZEdit());
  }, []);

  const nextPage = () => {
    const skip = filter.skip;
    setFilter({ ...filter, skip: skip + 10, page: filter.page + 1 });
  };

  const previousPage = () => {
    const skip = filter.skip;
    setFilter({ ...filter, skip: skip - 10, page: filter.page - 1 });
  };

  const firstPage = () => {
    setFilter({ ...filter, skip: 0, page: 0 });
  };


  const clearZendesk = () => {
    dispatch(clearZendeskTicket());
  };

  const closeEditTicketModal = () => {
    setEditTicketModal(false);
    dispatch({
      type: CLEAR_TICKET_FOR_EDIT,
    });
  };
  const closeCancelTicketModal = () => {
    setOpenCancelTicketModal(false);
    dispatch({
      type: CLEAR_TICKET_FOR_EDIT,
    });
  };
  const closeCancelTicketFeeModal = () => {
    setOpenCancelTicketFeeModal(false);
    dispatch({
      type: CLEAR_TICKET_FOR_EDIT,
    });
  };
  function pagination(props) {
    return (
      <td style={paginationStyle}>
        <Pagination
          translate={t}
          {...props}
          classes={{ ...classesMaterial }}
          page={filter.page}
          last={last}
          empty={empty}
          numberOfElements={numberOfElements}
          nextPage={nextPage}
          previousPage={previousPage}
          rowsPerPage={10}
          firstPage={firstPage}
        />
      </td>
    );
  }

  const options = optionsGeneralArchivedTickets(height * 0.65, 44);

  // @material-table/core renders these as the element *type*
  // (React.createElement(props.components.Pagination, ...)), so a new function
  // identity on each render unmounts and remounts the whole toolbar/paginator -
  // which tears down the paginator tooltips mid-hover. The identities are
  // therefore created once, and read the current closures through a ref so they
  // still see fresh state.
  const renderToolbar = useRef();
  const renderPagination = useRef();
  renderToolbar.current = toolbar;
  renderPagination.current = pagination;

  const tableComponents = useMemo(
    () => ({
      Toolbar: (props) => renderToolbar.current(props),
      Pagination: (props) => renderPagination.current(props),
    }),
    []
  );

  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth={false} className={classes.container}>
          {isLoading && <LoadingIndicator />}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className="text-center">
                <div className="row content">
                  <div className="col-sm-12">
                    <div
                      className={classes.paper}
                      style={{ width: '100%', minWidth: '3000px', overflowX: 'hidden'}}
                      aria-busy={isGridLoading}
                    >
                      <LiveRegion
                        message={
                          isGridLoading
                            ? t("MaterialTable.loadingRows")
                            : t("MaterialTable.rowsLoaded", { count: numberOfElements })
                        }
                      />
                      <GridProgress busy={showGridProgress} />
                      {showPictures && (
                        <ModalForPropotionalPicture
                          closePictures={handleCloseModalForPictures}
                          showPictures={showPictures}
                          images={images}
                        />
                      )}
                      {showVideos && (
                        <ModalForVideoPlaying
                          closeVideos={handleCloseModalForVideos}
                          showVideos={showVideos}
                          videos={videos}
                        />
                      )}
                      {openCommentModal && (
                        <ModalAddComment
                          open={openCommentModal}
                          addComment={addComment}
                          close={toogleModalForComment}
                          defaultValue={commentDefaultValue}
                        />
                      )}

                      {openModalOwnerDetails && (
                        <OwnerDetailsModal
                          open={openModalOwnerDetails}
                          setModalOpen={setOpenModalOwnerDetails}
                          owner={selectedOwner}
                          onClose={() => {
                            setOpenModalOwnerDetails(false);
                            setSelectedOwner("");
                          }}
                        />
                      )}

                      {zendeskDetailsModalOpen && (
                        <ModalZendeskDetails
                          open={zendeskDetailsModalOpen}
                          zendeskId={zendeskId}
                          owner={selectedOwner}
                          onClose={() => {
                            setZendeskDetailsModalOpen(false);
                            setZendeskId(null);
                            clearZendesk();
                          }}
                        />
                      )}

                      {objectionOpen && (
                        <ObjectionModal
                          objectionOpen={objectionOpen}
                          close={() => setObjectionOpen(false)}
                          objection={objection}
                        />
                      )}
                      {dateModalOpen && (
                        <DateModal
                          open={dateModalOpen}
                          close={() => setDateModalOpen(false)}
                          filter={filter}
                          setFilter={setFilter}
                          refDate={refDate}
                        />
                      )}
                      {openManualPaymentModal && (
                        <ModalManualPayment
                          manuallyPayTicket={manuallyPayTicket}
                          open={openManualPaymentModal}
                          close={() => setOpenManualPaymentModal(false)}
                          ticketForEdit={ticketForEdit}
                        />
                      )}
                      {editTicketModal && (
                        <ModalEditTicket
                          open={editTicketModal}
                          close={() => closeEditTicketModal()}
                          ticket={ticketForEdit}
                          editTicket={editTicket}
                          cancelTicket={ticketCancel}
                          zoneCountryCode={ticketForEdit.gasStationZone.countryCode}
                        />
                      )}
                      {resetTicketModal && (
                        <ModalResetTicket
                          open={resetTicketModal}
                          close={() => setResetTicketModal(false)}
                          ticket={ticketForReset}
                          onConfirm={handleResetTicket}
                        />
                      )}
                      {pendingDocumentAction && (
                        <ModalSendViaPingen
                          open={!!pendingDocumentAction}
                          generating={generatingDocument}
                          close={() => setPendingDocumentAction(null)}
                          onConfirm={handleSendViaPingenConfirm}
                        />
                      )}
                      {ticketAuditModal && (
                        <ModalAuditTicket
                          open={ticketAuditModal}
                          close={() => setTicketAuditModal(false)}
                          ticketForAudit={ticketForAudit}
                        />
                      )}
                      {customerDocumentHistoryModal && (
                        <ModalCustomerDocumentHistory
                          open={customerDocumentHistoryModal}
                          close={() => setCustomerDocumentHistoryModal(false)}
                          ticketNumber={ticketNumberForCustomerDocumentHistory}
                        />
                      )}
                      {openCancelTicketModal && (
                        <ModalCancelTicket
                          cancelTicket={ticketCancel}
                          open={openCancelTicketModal}
                          close={() => setOpenCancelTicketModal(false)}
                          ticketForEdit={ticketForEdit}
                        />
                      )}
                      {openCancelTicketFeeModal && (
                        <ModalCancelTicket
                          cancelTicket={ticketFeeCancel}
                          open={openCancelTicketFeeModal}
                          close={() => setOpenCancelTicketFeeModal(false)}
                          ticketForEdit={ticketForEdit}
                        />
                      )}
                      {openViolatorsAddressLocked && (
                        <ViolatorsAddressLockedModal
                          open={openViolatorsAddressLocked}
                          close={() => {
                            setOpenViolatorsAddressLocked(false);
                            setViolatorDetails(null);
                          }}
                          ticket={violatorDetails}
                        />
                      )}

                      {openModalGasStationZoneDetails && (
                        <GasStationDetailsModal
                          open={openModalGasStationZoneDetails}
                          onClose={() =>
                            setOpenModalGasStationZoneDetails(false)
                          }
                          gasStationId={selectedGasStationZoneId}
                          openGasStationEditModal={openGasStationZoneEditModal}
                        />
                      )}

                      {openModalEditGasStationZone && (
                        <EditGasStationModal
                          open={openModalEditGasStationZone}
                          closeOnEsc
                          onClose={() => setOpenModalEditGasStationZone(false)}
                        />
                      )}
                      {openCloseTicketModal && (
                        <ModalCloseTicket
                          closeTicket={ticketClose}
                          open={openCloseTicketModal}
                          close={() => setOpenCloseTicketModal(false)}
                          ticketForEdit={ticketForEdit}
                        />
                      )}
                      <MaterialTable
                        icons={{
                          Filter: () => (
                            <img src={MagnifyingGlass} alt="search" />
                          ),
                        }}
                        title="Parking zones"
                        data={violations}
                        columns={DriveOffColumns({
                          t: t,
                          setShowPictures: setShowPictures,
                          setImages: setImages,
                          setShowVideos: setShowVideos,
                          setVideos: setVideos,
                          setObjectionOpen: setObjectionOpen,
                          setObjection: setObjection,
                          generateDocumentation: generateDocumentation,
                          cancelViolation: cancelViolation,
                          cancelViolationFee: cancelViolationFee,
                          changeTicketLegalStatus: changeTicketLegalStatus,
                          changeTicketDocumentLanguage: changeTicketDocumentLanguage,
                          keycloak: keycloak,
                          manuallyPayTicket: manuallyPayTicket,
                          generateReminderPaymentSlip:
                          generateReminderPaymentSlip,
                          generateLastReminderSlip: generateLastReminderSlip,
                          archiveTicket: archiveTicket,
                          showArchivedList: showArchivedList,
                          archivedCellStyle: archivedCellStyle,
                          generatePaymentSlip: generatePaymentSlip,
                          toogleModalForComment,
                          setTicketNumberInCommentModal,
                          setCommentDefaultValue,
                          setEditTicketModal,
                          setResetTicketModal,
                          setTicketForEdit,
                          setTicketForReset,
                          setPendingDocumentAction,
                          setOpenModalOwnerDetails,
                          setSelectedOwner,
                          setFilter: setFilter,
                          filter: filter,
                          setZendeskDetailsModalOpen:
                          setZendeskDetailsModalOpen,
                          setZendeskId: setZendeskId,
                          setDateModalOpen,
                          refDate: refDate,
                          setViolatorDetails,
                          setOpenViolatorsAddressLocked,
                          createOperationalDocument,
                          setTicketAuditModal: setTicketAuditModal,
                          setTicketForAudit: setTicketForAudit,
                          setCustomerDocumentHistoryModal: setCustomerDocumentHistoryModal,
                          setTicketNumberForCustomerDocumentHistory: setTicketNumberForCustomerDocumentHistory,
                          setOpenManualPaymentModal,
                          setOpenCancelTicketModal,
                          setOpenCancelTicketFeeModal,
                          setSelectedGasStationZoneId,
                          setOpenModalGasStationZoneDetails,
                          setOpenCloseTicketModal
                        })}
                        options={{
                          ...options,
                          sorting: false,
                          draggable: false,
                          tableLayout: "auto",
                        }}
                        components={tableComponents}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </main>
    </div>
  );
}
